import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../../../context/UserContext";
import "../../HPComponents/HP_Hero/HP_Hero.css";
import "../../../../components/Buttons/SignUpButton/SignUpButton.css";
import heroImage from "../../../../img/icons/heroimage.png";

const Hero = () => {
  const { user } = useContext(UserContext);

  return (
    <section className="Hero">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start mb-5">
            <Link to="/festivals" className="User_celebration d-block mb-3">
              <img
                src={heroImage}
                alt="Move n Muse - Join the Movement"
                className="imgggg"
              />
            </Link>
          </div>
          <div className="col-md-6 hero-content">
            <h1>
              <span className="hero-headline-primary">Your <span className="hero-headline-highlight">trusted</span> event guide </span><span className="hero-headline-accent">the dance world has been missing.</span>
            </h1>
            <p>
              Welcome to the first platform where dancers anonymously share their honest event reviews, give each other Kudos, and build a more transparent, safer global dance culture.
            </p>
            <div className="d-flex justify-content-center justify-content-md-start">
              {user ? (
                <Link to="/festivals" className="sign-up-button">
                  Explore Events
                </Link>
              ) : (
                <Link to="/login?tab=signup" className="sign-up-button">
                  Join the Community
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
